/**
 * Central registry of telemetry event names and property keys.
 * Add new feature events / property keys here — call sites should never
 * pass a bare string literal to trackFeatureUsage/trackException.
 */

export const FeatureEvent = {
    Login: 'Login',
    Logout: 'Logout',
    AccessDenied: 'AccessDenied',
    OnboardingStarted: 'OnboardingStarted',
    OnboardingStepCompleted: 'OnboardingStepCompleted',
    OnboardingCompleted: 'OnboardingCompleted',
    SearchIndexerRunStarted: 'SearchIndexerRunStarted',
    SearchIndexerRunCompleted: 'SearchIndexerRunCompleted',
    DashboardScanStarted: 'DashboardScanStarted',
    DashboardScanCompleted: 'DashboardScanCompleted',
} as const;

export type FeatureEventName = (typeof FeatureEvent)[keyof typeof FeatureEvent];

/** Property keys used in trackFeatureUsage's properties bag. Reuse these instead of retyping the string. */
export const EventProp = {
    Route: 'route',
    Allowed: 'allowed',
    Reason: 'reason',
    Step: 'step',
    SourceCount: 'sourceCount',
    ErrorCount: 'errorCount',
    ForceRefresh: 'forceRefresh',
    PageCount: 'pageCount',
} as const;

/** "phase" tag values passed to trackException, identifying which flow the error came from. */
export const ExceptionPhase = {
    Login: 'login',
    MsalInit: 'msalInit',
    OnboardingComplete: 'onboardingComplete',
    DashboardScan: 'dashboardScan',
} as const;

/** Property keys used in trackException's properties bag (distinct from EventProp — exception-only). */
export const ExceptionProp = {
    Phase: 'phase',
    ComponentStack: 'componentStack',
} as const;
